import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { Text, colors } from '@retailer-platform/shared-components'
import { type Moment } from 'moment'
import { useDomainMessages } from 'domains/aggregate-store-performance/utils/domain/intl'

const UpdatedAtContainer = styled.div({
  alignSelf: 'flex-end',
})

const StyledText = styled(Text)({
  display: 'block',
  color: colors.GRAYSCALE.X50,
})

interface UpdatedAtProps {
  updatedAt?: Moment
}

export const UpdatedAt: FunctionComponent<UpdatedAtProps> = ({ updatedAt }) => {
  const messages = useDomainMessages({
    updatedAt: 'aggregateStorePerformanceDomain.updatedAt.text',
  })
  return (
    <UpdatedAtContainer>
      {updatedAt ? (
        <StyledText size="small">{`${messages.updatedAt} ${updatedAt.format(
          'MMM D, [at] h:mma'
        )}`}</StyledText>
      ) : (
        ''
      )}
    </UpdatedAtContainer>
  )
}
